module.exports = __webpack_public_path__ + "static/media/napoleon-4.86df09d7.png";